@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  position: relative;
}

.recipients {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  overflow: hidden;

  > * {
    margin-right: 4px;
  }
}

.input {
  @include md-sohne;
  background-color: transparent;
  min-width: 10px;
  min-height: 36px;
  caret-color: var(--selected-stroke);
  color: var(--dark-80);
  width: 100%;

  [data-autopilot-system-redesign='on'] & {
    caret-color: var(--dark-80);
  }

  &::placeholder {
    color: var(--dark-40);
  }

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }
}

.portal {
  > div {
    z-index: 1003;
  }
}

.sharedContainer {
  width: 100%;
}

.suggestionsPanel {
  @include thinScrollbar;
  @include shadow-3;

  background: var(--light-100);
  border-radius: 8px;
  margin-top: 6px;
  max-height: 500px;
  overflow: auto;
  padding: 4px;
  width: 100%;
  z-index: 1;

  @include for-phone-only {
    max-height: 200px;
    width: 300px;
  }
}

.searchHeader {
  @include sm-sohne;

  color: var(--dark-40);
  padding: 8px 8px 4px;
}

div.badgeSelected {
  background: var(--dark-10);
}

.hideCaret {
  caret-color: transparent;
}
